import { type ResultCount } from "~/GearboxSelectionAssistant/models";

export function calculateVisibleAttributes(possibleAttributes: string[], hasAttributeValues: Record<string, boolean>) {
  return possibleAttributes.filter((attribute) => hasAttributeValues[attribute]);
}

/**
 * For every entry check if there is any value with a value > 0, if so, the attribute is visible
 * @param resultCount
 */
export function transformResultCountsToVisibilityMap(resultCount: Record<string, ResultCount>) {
  return Object.keys(resultCount).reduce((acc, code) => {
    acc[code] = hasAnyResults(resultCount[code]);
    return acc;
  }, {} as Record<string, boolean>);
}

function hasAnyResults(resultCount: ResultCount) {
  return Object.values(resultCount).some((count) => count > 0);
}
